import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import {
  AbstractControl,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import { InvoiceDetailModel } from '@app/core/models/invoices/invoice-detail.model';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-invoice-voucher-form',
  templateUrl: './invoice-voucher-form.component.html',
  styleUrls: ['./invoice-voucher-form.component.scss'],
})
export class InvoiceVoucherFormComponent implements OnInit, OnDestroy {
  invoiceViewType: string;
  submitted = true;
  formData = new FormData();
  unsubscribe$: Subject<boolean> = new Subject<boolean>();
  isFormUpdated: boolean = false;

  public InvoiceDetailForm: UntypedFormGroup;

  @Input() IsReadOnly: boolean;
  @Input() InvoiceDetailModel: InvoiceDetailModel;

  constructor(private formBuilder: UntypedFormBuilder) {}

  ngOnInit(): void {
    this.buildFormControls();
    this.isFormUpdated = false;
  }

  get formControls(): { [key: string]: AbstractControl } {
    return this.InvoiceDetailForm.controls;
  }

  buildFormControls() {
    this.InvoiceDetailForm = this.formBuilder.group({
      VoucherAnalyticalSection: new UntypedFormControl(
        {
          disabled: this.IsReadOnly,
          value: this.InvoiceDetailModel.VoucherAnalyticalSection,
        },
        []
      ),

      VoucherAnalyticalCode: new UntypedFormControl(
        {
          disabled: this.IsReadOnly,
          value: this.InvoiceDetailModel.VoucherAnalyticalCode,
        },
        []
      ),

      VoucherComment: new UntypedFormControl(
        {
          disabled: this.IsReadOnly,
          value: this.InvoiceDetailModel.VoucherComment,
        },
        []
      ),

      VoucherDepartment: new UntypedFormControl({
        disabled: this.IsReadOnly,
        value: this.InvoiceDetailModel.VoucherDepartment,
      }),
    });
  }

  ngOnDestroy() {
    this.unsubscribe$.next(true);
  }
}
